<div class="skl-sync-settings" aria-busy="true" aria-label="Loading CMDB sync settings">
  <div class="skl-card">
    <div class="skl-card__body">
      <app-skeleton width="200px" height="18px" borderRadius="4px" marginBottom="12px"></app-skeleton>
      <app-skeleton width="82%" height="13px" borderRadius="3px" marginBottom="8px"></app-skeleton>
      <app-skeleton width="70%" height="13px" borderRadius="3px" marginBottom="24px"></app-skeleton>

      <div class="skl-checkbox-row">
        <app-skeleton width="180px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
      </div>
      <app-skeleton width="68%" height="13px" borderRadius="3px" marginBottom="18px"></app-skeleton>

      <div class="skl-checkbox-row">
        <app-skeleton width="150px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
      </div>
      <app-skeleton width="74%" height="13px" borderRadius="3px" marginBottom="24px"></app-skeleton>

      <div class="skl-field-grid">
        <div>
          <app-skeleton width="130px" height="13px" borderRadius="3px" marginBottom="10px"></app-skeleton>
          <app-skeleton width="100%" height="40px" borderRadius="4px" marginBottom="0"></app-skeleton>
          <app-skeleton width="72%" height="13px" borderRadius="3px" marginBottom="0" class="skl-field-hint"></app-skeleton>
        </div>
      </div>

      <div class="skl-actions">
        <app-skeleton width="118px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
      </div>
    </div>
  </div>
</div>